import { request } from './api';

interface ICity {
  id: number;
  name: string;
}

export interface IMarket {
  id: number;
  name: string;
  address: string | null;
  city: ICity;
}

export interface ICreateMarket {
  name: string;
  address: string;
  city: string;
}

export function getMarkets() {
  return request<IMarket[]>('get', 'markets');
}

export function createMarket(market: ICreateMarket) {
  return request<IMarket>('post', 'markets', { market });
}

export function updateMarket(id: number, market: ICreateMarket) {
  return request<IMarket>('patch', `markets/${id}`, { market });
}

export function deleteMarket(id: number) {
  return request<IMarket>('delete', `markets/${id}`);
}



// WEBPACK FOOTER //
// ./src/api/v2/markets.api.ts